export const PhoneNumberType: Record<string, string> = {
  Wireline: "wireline",
  TollFree: "tollfree"
};
